import { validationMessagesConfig } from './config';

export const validateForm = (values) => {

  const errors = {};

  const { email, selectedProvider, isPolicyAgreed } = values;

  if (email.trim().length === 0) {
    errors['emailError'] = validationMessagesConfig.email;
  }

  if (selectedProvider.value.length === 0) {
    errors['providerError'] = validationMessagesConfig.provider;
  }

  if (!isPolicyAgreed) {
    errors['policyError'] = validationMessagesConfig.policy;
  }

  return errors;
};
